import baseInitialize from './base';
import BasicAccordion from 'components/basicAccordion/BasicAccordion';

baseInitialize();

BasicAccordion.attachTo('.js-sitemap-accordion', {
  maxBreakPoint: 'xsmall',
  contentSelector: '.js-sitemap-accordion-content',
  toggleSelector: '.js-sitemap-accordion-toggle'
});
